// Use this file to define all the ACLStore related utility functions
// which are used in multiple parts of application

import ACLStore from "lib/aclStore";
import {
  ENABLE_IBIS_UI_REVAMP,
  ENABLE_MCGRAW_HILL_LTI_TOOL,
  ENABLE_WALKME_INTEGRATION,
  ENABLE_WORKFLOW_POC_BUTTON,
  ENABLE_WORKFLOWS,
  ENABLE_WORKFLOWS_IN_TODDLE_2_0,
  TODDLE_2_O_PERMISSION,
  AY_WISE_PERM_SETUP_PERMISSION,
  IS_ESF_MASTER_CLASS,
  IS_SENTRAL_ESF_ORG,
  ENABLE_THIRD_PARTY_REDIRECT_URL_CARD,
  ENABLE_BULK_ACTIONS,
  ENABLE_FAMILY_INVITE_FLOW_V2,
  ENABLE_SENTRAL_NOTIFICATION,
  DISABLE_FAMILY_INVITE_OPTIONS,
  MODULE_SETTINGS_V2,
  ENABLE_ENROL_WITHDRAWAL_DATE,
  ENABLE_USER_MIDDLE_NAME,
  ENABLE_STUDENT_MIDDLE_NAME,
  ENABLE_USER_PREFIX,
  ENABLE_USER_PRONOUNS,
  ENABLE_STUDENT_BLOCKING,
  ENABLE_ADD_ON_IBIS_REVAMP,
  ENABLE_PROGRAMME_RESTRICTION_FOR_STAFF,
  ENABLE_ACCOUNT_CONFIGURATION,
  ENABLE_ADMIN_NAVIGATION_REVAMP,
  ENABLE_ROLES_AND_PERMISSIONS_CONFIGURATION,
  ENABLE_COURSE_CODE_SHEET,
  ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION,
  ENABLE_STUDENT_IMPERSONATION,
  BULK_UPLOAD_FAMILY_GET_ROSTERED,
  BEHAVIOUR_RNP_CONSUMPTION_PERMISSION,
  ENABLE_EXAM_SESSION_ON_CURRICULUM,
  ENABLE_WEEKLY_PLANNER_COPY_CONTENT_TO_DATE_RANGE,
  BEHAVIOUR_RNP_CONFIGURATION_PERMISSION,
  ENABLE_CONTEXTUAL_HELP,
  GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS,
  ENABLE_IDP_INIT_FLOW_USING_SAML,
  ENABLE_1P0_TO_2P0_AYT,
  ALLOW_PLANNER_AND_GRADING_SETUP_OVERRIDES,
  ENABLE_STUDENT_EXTERNAL_ASSESSMENTS,
  ENABLE_ACCOUNT_LEVEL_DEPARTMENT,
  ENABLE_SENTRAL_URL_OPEN_IN_NEW_TAB,
  ENABLE_BULK_ACTION_POLLING_CANCELLATION,
  ENABLE_BULK_UPLOAD_TEMPLATE_DOWNLOAD_TEMPORAL,
  ENABLE_REACT_PLAYER_VIDEO_MODALITY,
  ENABLE_PARENT_STANDARDS_TAGGING,
  ENABLE_PARENT_ATLS_TAGGING,
  SHOW_FLAT_LIST_FOR_STANDARDS,
  SHOW_FLAT_LIST_FOR_ATLS,
  IS_MFA_ENABLED,
  ALLOW_CLASS_EXCLUSION_WHEN_EXCLUDING_COURSE,
  ENABLE_POWER_BI_CARDS,
  ENABLE_SUBMISSION_STATUS_OVERRIDE,
  ENABLE_QUICK_COPY_UPDATE,
  ENABLE_ASSIGNMENTS_UNIT_TAGGING_IN_2_0,
  ENABLE_PARENT_DATASETS_TAGGING,
  ENABLE_STUDENT_TRANSFER,
  ACCOUNT_LEVEL_GRADING_PERIODS_PERMISSION,
} from "Constants/permissionConstants";

export const isDemoDayBannerVisiblityEnabled = () => {
  return ACLStore.can("FeatureFlag:ShowDemoDayBanner");
};

export const IsReflectiveProjectDpTagEnabled = () => {
  return ACLStore.can("Common:ReflectiveProject");
};

export const showGlobalHeaderInLibrary = () => {
  return ACLStore.can("FeatureFlag:EnableToddleLibraryGlobalHeader");
};

export const getIsWorkflowsEnabled = () => {
  return ACLStore.can(ENABLE_WORKFLOWS);
};

export const getIsMultiOrgWorkflowsEnabled = () => {
  return ACLStore.can(ENABLE_WORKFLOWS_IN_TODDLE_2_0);
};

export const getIsWorkflowPOCButtonEnabled = () => {
  return ACLStore.can(ENABLE_WORKFLOW_POC_BUTTON);
};

export const getIsMcGrawHillLTIToolEnabled = () => {
  return ACLStore.can(ENABLE_MCGRAW_HILL_LTI_TOOL);
};

export const getIsIBISUIRevampEnabled = () => {
  return ACLStore.can(ENABLE_IBIS_UI_REVAMP);
};

export const getIsIBISAnticipatedCategoryEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableAnticipatedRegistrationCategory");
};

export const getIsEmailEnabledInIBISCandidateInfo = () => {
  return ACLStore.can("IBIS:EnableEmailInCandidateInfo");
};

export const getIsIBISEnabledInAddOnManager = () => {
  return ACLStore.can(ENABLE_ADD_ON_IBIS_REVAMP);
};

export const isSentralPortalFeatureEnabled = permission => {
  return ACLStore.can(permission);
};

export const getToddle20EnableStatus = () => {
  return ACLStore.can(TODDLE_2_O_PERMISSION);
};

export const getIsWalkMeIntegrationEnabled = () => {
  return ACLStore.can(ENABLE_WALKME_INTEGRATION);
};

export const getIsSentralESFEnabledOrg = () => {
  return ACLStore.can(IS_SENTRAL_ESF_ORG);
};

export const getIsESFMasterClassEnabled = () => {
  return ACLStore.can(IS_ESF_MASTER_CLASS);
};

export const getIsSentralUrlOpenInNewTabEnabled = () => {
  return ACLStore.can(ENABLE_SENTRAL_URL_OPEN_IN_NEW_TAB);
};

export const getIs2WaySyncForTeacherNamesEnabled = () => {
  return ACLStore.can("FeatureFlag:Enable2WaySyncForTeacherNames");
};

export const getIsAllowedClassExclusion = () => {
  return ACLStore.can(ALLOW_CLASS_EXCLUSION_WHEN_EXCLUDING_COURSE);
};

export const getIsMultipleHomeroomAdvisorsEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableMultipleHomeroomAdvisors");
};

export const getIsAYWisePermsSetupEnabled = () => {
  return ACLStore.can(AY_WISE_PERM_SETUP_PERMISSION);
};

export const getIsEnabledAssignmentImprovements = () => {
  return ACLStore.can("FeatureFlag:AssignmentImprovements");
};

export const getIsGradebookImprovementsEnabled = () => {
  return ACLStore.can("FeatureFlag:GradebookImprovements");
};

export const getIsThirdPartyRedirectUrlCardEnabled = () => {
  return ACLStore.can(ENABLE_THIRD_PARTY_REDIRECT_URL_CARD);
};

export const getIsStudentAssignmentFeedRevampEnabled = () => {
  return ACLStore.can("FeatureFlag:StudentAssignmentFeedRevamp");
};

export const isBulkActionsEnabled = () => {
  return ACLStore.can(ENABLE_BULK_ACTIONS);
};

export const getIsEnabledExcusedStatusInAssignment = () => {
  return ACLStore.can("FeatureFlag:EnableExcusedStatusInAssignment");
};

export const isHomeroomEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableHomeroom");
};

export const isFamilyInviteFlowV2 = () => {
  return ACLStore.can(ENABLE_FAMILY_INVITE_FLOW_V2);
};

export const getIsSentralNotificationEnabled = () => {
  return ACLStore.can(ENABLE_SENTRAL_NOTIFICATION);
};

export const getIsFamilyInviteOptionsDisabled = () => {
  return ACLStore.can(DISABLE_FAMILY_INVITE_OPTIONS);
};

export const getIsAddClassPaginationEnabled = () => {
  return ACLStore.can("FeatureFlag:PaginateClassesInAssignmentSharing");
};

export const getIsModuleSettingsV2Enabled = () => {
  return ACLStore.can(MODULE_SETTINGS_V2);
};

export const getIsEnrollWithdrawalDateEnabled = () => {
  return ACLStore.can(ENABLE_ENROL_WITHDRAWAL_DATE);
};

export const getIsStudentMiddleNameEnabled = () => {
  return ACLStore.can(ENABLE_STUDENT_MIDDLE_NAME);
};

export const getIsUserMiddleNameEnabled = () => {
  return ACLStore.can(ENABLE_USER_MIDDLE_NAME);
};

export const getIsAIDebugModeEnabled = () => {
  return (
    ACLStore.can("IdentityAccess:EnableAIDebugMode") ||
    ACLStore.can("Common:EnableAIDebugMode")
  );
};

export const getIsToddleDocCreationEnabledForStudent = () => {
  return ACLStore.can("FeatureFlag:EnableToddleDocCreationForStudent");
};

export const getIsUserPrefixEnabled = () => {
  return ACLStore.can(ENABLE_USER_PREFIX);
};

export const getIsUserPronounsEnabled = () => {
  return ACLStore.can(ENABLE_USER_PRONOUNS);
};

export const isStudentBlockingFeatureEnabled = () => {
  return ACLStore.can(ENABLE_STUDENT_BLOCKING);
};

export const getIsProgrammeRestrictionEnabledForStaff = () => {
  return ACLStore.can(ENABLE_PROGRAMME_RESTRICTION_FOR_STAFF);
};

export const getIsAdminNavigationFor10Accounts = () => {
  return (
    ACLStore.can(ENABLE_ADMIN_NAVIGATION_REVAMP) &&
    !ACLStore.can(ENABLE_ACCOUNT_CONFIGURATION) &&
    ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION)
  );
};

export const getIsNewAdminUIEnabled = () => {
  return (
    ACLStore.can([ENABLE_ACCOUNT_CONFIGURATION]) ||
    getIsAdminNavigationFor10Accounts()
  );
};

export const getIsRnPConfigurationEnabled = () => {
  return ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONFIGURATION);
};

export const getIsAITutorModalitiesEnabled = () => {
  return ACLStore.can("FeatureFlag:AITutorModalities");
};

export const getIsChinaTemplate = () => {
  return ACLStore.can("FeatureFlag:UseChinaTemplateForFamilyInvite");
};

export const getIsAITutorEnhancementsV2Enabled = () => {
  return (
    ACLStore.can("FeatureFlag:AITutorEnhancementsV2") ||
    getIsAITutorModalitiesEnabled()
  );
};

export const getIsAITutorInEEEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableAITutorInEE");
};

export const getIsCourseCodeSheetEnabled = () => {
  return ACLStore.can(ENABLE_COURSE_CODE_SHEET);
};

export const getIsAssessmentTypeConfigurationEnabled = () => {
  return ACLStore.can("FeatureFlag:AssessmentTypeConfiguration");
};

export const getIsAddOnManagerV2Enabled = () => {
  return ACLStore.can("FeatureFlag:EnableNewAddonManager");
};

export const getIsAcademicProgramCreationAllowed = () => {
  return ACLStore.can("IdentityAccess:AllowAcademicProgramCreation");
};

export const getIsAssignmentCopyLinkOptionEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableAssignmentCopyLinkOption");
};

export const getIsCreateDuplicateAssignmentIn2P0Enabled = () => {
  return ACLStore.can("FeatureFlag:EnableCreateDuplicateAssignmentIn2.0");
};

export const getIsStudentImpersonationEnabled = () => {
  return ACLStore.can(ENABLE_STUDENT_IMPERSONATION);
};

export const getIsResetStudentSignInCodeEnabled = () => {
  return ACLStore.can("FeatureFlag:ResetStudentSigninCode");
};

export const getIsResetFamilyInviteCodeEnabled = () => {
  return ACLStore.can("FeatureFlag:ResetFamilyInviteCode");
};

export const getIsCoursePlanRouteEnabled = () => {
  return ACLStore.can("FeatureFlag:CoursePlanRouteRevamp");
};

export const getIsBehaviourRnPModuleConsumptionEnabled = () => {
  return ACLStore.can(BEHAVIOUR_RNP_CONSUMPTION_PERMISSION);
};

export const getIsBehaviourRnPModuleConfigurationEnabled = () => {
  return ACLStore.can(BEHAVIOUR_RNP_CONFIGURATION_PERMISSION);
};

export const getIsBulkUploadFamilyGetRosteredEnabled = () => {
  return ACLStore.can(BULK_UPLOAD_FAMILY_GET_ROSTERED);
};

export const getIsAIEditDeleteButtonEnabled = () => {
  return (
    ACLStore.can("IdentityAccess:ShowEditIconInAITutor") ||
    ACLStore.can("Common:ShowEditIconInAITutor")
  );
};

export const getIsExamSessionOnCurriculumEnabled = () => {
  return ACLStore.can(ENABLE_EXAM_SESSION_ON_CURRICULUM);
};
export const getIsIntercomAusWorkspaceEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableIntercomAusWorkspace");
};

export const getIsIntercomV2Enabled = () => {
  return ACLStore.can("FeatureFlag:IntercomV2");
};

export const getIsTimetablePlannerEnabled = () => {
  return ACLStore.can("FeatureFlag:TimetableCoursePlanner");
};

export const getIsCopyContentToDateRangeEnabled = () => {
  return ACLStore.can(ENABLE_WEEKLY_PLANNER_COPY_CONTENT_TO_DATE_RANGE);
};

export const getIsAccountConfigurationEnabled = () =>
  ACLStore.can(ENABLE_ACCOUNT_CONFIGURATION);

export const isCustomRoleCreationAllowed = () => {
  return ACLStore.can("FeatureFlag:AllowCustomRoleCreationInRnP");
};

export const getIsStartOrgCopyPipelineEnabled = () => {
  return ACLStore.can("IdentityAccess:StartOrgCopyPipeline");
};

export const getIsManualAcademicYearSwitchEnabled = () => {
  return ACLStore.can("FeatureFlag:ManualAcademicYearSwitch");
};

export const getIsLissTimetableSyncEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableLissTimetableSync");
};

export const getIsFileUploadOnRosterSyncEnabled = () => {
  return ACLStore.can("enableFileUploadButtonOnRosterSync");
};

export const getIsContextualHelpEnabled = () => {
  return ACLStore.can(ENABLE_CONTEXTUAL_HELP);
};

export const isModuleSearchEnabledInGlobalSearch = () => {
  return ACLStore.can(
    GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.MODULES_SEARCH
  );
};

export const isInsightsSearchEnabledInGlobalSearch = () => {
  return ACLStore.can(
    GLOBAL_SEARCH_CHIPS_FEATURE_FLAGS_MAPPINGS.INSIGHTS_SEARCH
  );
};

export const getIsIdpInitFlowUsingSamlEnabled = () => {
  return ACLStore.can(ENABLE_IDP_INIT_FLOW_USING_SAML);
};

export const getIs1p0To2p0AYTEnabled = () => {
  return ACLStore.can(ENABLE_1P0_TO_2P0_AYT);
};

export const getIsPlannerAndGradingSetupOverridesAllowed = () => {
  return ACLStore.can(ALLOW_PLANNER_AND_GRADING_SETUP_OVERRIDES);
};

export const getIsAcademicYearTransitionV2Enabled = () => {
  return ACLStore.can("FeatureFlag:AcademicYearTransitionV2");
};

export const getIsTimetablePlannerColoredSlotsEnabled = () => {
  return ACLStore.can("FeatureFlag:TimetablePlannerColoredSlots");
};

export const getIsStudentExternalAssessmentsEnabled = () => {
  return ACLStore.can(ENABLE_STUDENT_EXTERNAL_ASSESSMENTS);
};

export const getIsAccountDepartmentEnabled = () => {
  return ACLStore.can(ENABLE_ACCOUNT_LEVEL_DEPARTMENT);
};

export const getIsUnitFlowRightPaneEnabled = () => {
  return ACLStore.can("FeatureFlag:UnitFlowInRightPane");
};

export const getIsBulkUploadTemplateDownloadTemporalEnabled = () => {
  return ACLStore.can(ENABLE_BULK_UPLOAD_TEMPLATE_DOWNLOAD_TEMPORAL);
};

export const getIsBulkActionPollingCancellationEnabled = () => {
  return ACLStore.can(ENABLE_BULK_ACTION_POLLING_CANCELLATION);
};

export const getIsIBGradeScaleV2ForNewGradingSetupEnabled = () => {
  return ACLStore.can("FeatureFlag:IBGradeScaleV2ForNewGradingSetup");
};
export const getIsImportFromClassFlowInCoursePlanEnabled = () => {
  return ACLStore.can("FeatureFlag:ImportFromClassFlowInCoursePlan");
};

export const getIsSubmissionStatusOverrideEnabled = ({
  isWorksheet = false,
  isAITutor = false,
} = {}) => {
  // Worksheet and AI Tutor student-end lifecycles (sessions, timers,
  // terminal ENDED state, re-attempt affordances) do not yet honour
  // overridden statuses — see CU-ASGN-174. Hide the override surfaces
  // entirely for these types until that interlock is implemented.
  if (isWorksheet || isAITutor) return false;
  return ACLStore.can(ENABLE_SUBMISSION_STATUS_OVERRIDE);
};

export const getIsReactPlayerVideoModalityEnabled = () => {
  return ACLStore.can(ENABLE_REACT_PLAYER_VIDEO_MODALITY);
};
export const isStandardsParentTaggingEnabled = () => {
  return ACLStore.can(ENABLE_PARENT_STANDARDS_TAGGING);
};

export const isATLsParentTaggingEnabled = () => {
  return ACLStore.can(ENABLE_PARENT_ATLS_TAGGING);
};

export const isDatasetsParentTaggingEnabled = () => {
  return ACLStore.can(ENABLE_PARENT_DATASETS_TAGGING);
};

export const getIsTimeAxisEnabledInPlanner = () => {
  return ACLStore.can("FeatureFlag:EnableClassPlannerTimeAxisView");
};

export const shouldShowFlatListForStandards = () => {
  return ACLStore.can(SHOW_FLAT_LIST_FOR_STANDARDS);
};

export const shouldShowFlatListForAtls = () => {
  return ACLStore.can(SHOW_FLAT_LIST_FOR_ATLS);
};

export const getIsShowEditLearningMomentEnabled = () => {
  return ACLStore.can("FeatureFlag:ShowEditLearningMoment");
};

export const getIsMfaEnabled = () => {
  return ACLStore.can(IS_MFA_ENABLED);
};

export const getIsAllSubmissionsNavigationImprovementsEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableAllSubmissionsNavigationImprovements");
};

export const getIsPowerBiCardsEnabled = () => {
  return ACLStore.can(ENABLE_POWER_BI_CARDS);
};

export const getIsQuickCopyUpdateEnabled = () => {
  return ACLStore.can(ENABLE_QUICK_COPY_UPDATE);
};

export const getIsAssignmentsUnitTaggingIn2_0Enabled = () => {
  return ACLStore.can(ENABLE_ASSIGNMENTS_UNIT_TAGGING_IN_2_0);
};

export const getIsLeAssessmentCreationEnabled = () => {
  return ACLStore.can("FeatureFlag:CreateLEInWeeklyPlanners");
};

export const checkIsUnitPlanViewRevampEnabledInLibrary = () => {
  return ACLStore.can("FeatureFlag:NewUnitPlanViewInLibrary");
};

export const getIsStudentTransferEnabled = () => {
  return ACLStore.can(ENABLE_STUDENT_TRANSFER);
};

export const getIsGlobalBinEnabled = () => {
  return ACLStore.can("FeatureFlag:GlobalBin");
};

export const getIsAccountLevelGradingPeriodsEnabled = () => {
  return ACLStore.can(ACCOUNT_LEVEL_GRADING_PERIODS_PERMISSION);
};

export const getIsUniversalParentEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableUniversalParent");
};
